import { render, staticRenderFns } from "./desfasFacturacion.vue?vue&type=template&id=46fb141b&scoped=true"
import script from "./desfasFacturacion.vue?vue&type=script&lang=js"
export * from "./desfasFacturacion.vue?vue&type=script&lang=js"
import style0 from "./desfasFacturacion.vue?vue&type=style&index=0&id=46fb141b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb141b",
  null
  
)

export default component.exports